import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface BranchListInterface {
  screenName: string | "";
}

const initialState: BranchListInterface = {
  screenName: "",
};

const branchListSlice = createSlice({
  name: "branchList",
  initialState,
  reducers: {
    setBranchListScreenName: (state, action: PayloadAction<BranchListInterface>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setBranchListScreenName } = branchListSlice.actions;
export default branchListSlice.reducer;
